function collectionPageUrl(href, sectionId, base) {
  const url = new URL(href, base);
  const origin = new URL(base).origin;
  if (url.origin !== origin || !url.pathname.includes('/collections/')) throw new Error('Invalid collection URL');
  url.hash = '';
  url.searchParams.set('section_id', sectionId);
  return url;
}
if (typeof module !== 'undefined') module.exports = {collectionPageUrl};
if (typeof document !== 'undefined') (() => {
  function setup(root = document) {
    const collection = root.matches?.('[data-yc-collection]') ? root : root.querySelector('[data-yc-collection]');
    if (!collection || collection.dataset.ready) return;
    collection.dataset.ready = 'true';
    if (collection.dataset.priceControls === 'false') {
      const current = new URL(location.href);
      const before = current.toString();
      current.searchParams.delete('filter.v.price.gte');
      current.searchParams.delete('filter.v.price.lte');
      if (current.searchParams.get('sort_by')?.startsWith('price-')) current.searchParams.delete('sort_by');
      if (current.toString() !== before) { location.replace(current); return; }
    }
    collection.querySelectorAll('[data-yh-category]').forEach(a => {
      if (a.dataset.yhCategory === collection.dataset.category) a.setAttribute('aria-current','page');
    });
    const dialog = collection.querySelector('#YcFilters');
    const trigger = collection.querySelector('[data-yc-open]');
    trigger?.addEventListener('click', () => dialog.showModal());
    collection.querySelector('[data-yc-close]')?.addEventListener('click', () => dialog.close());
    dialog?.addEventListener('close', () => trigger?.focus());
    dialog?.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right) dialog.close();
    });
    dialog?.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const items = [...dialog.querySelectorAll('button,a[href],input,select')].filter(e => !e.disabled && e.type !== 'hidden' && e.getClientRects().length);
      const first = items[0], last = items.at(-1);
      if (event.shiftKey && document.activeElement === first) {event.preventDefault();last.focus();}
      else if (!event.shiftKey && document.activeElement === last) {event.preventDefault();first.focus();}
    });
    collection.querySelector('[data-yc-sort]')?.addEventListener('change', event => {
      const form = event.target.form;
      form.action = form.action.split('#')[0]+'#pieces'; form.requestSubmit();
    });
    if (dialog) dialog.querySelector('form').action += '#pieces';
    let busy = false;
    collection.addEventListener('click', async event => {
      const link = event.target.closest('[data-yc-more]');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault(); if (busy) return;
      busy = true; link.setAttribute('aria-disabled','true'); link.textContent = link.dataset.loading;
      const error = collection.querySelector('[data-yc-error]'); error.hidden = true;
      try {
        const response = await fetch(collectionPageUrl(link.href, collection.dataset.sectionId, location.href));
        if (!response.ok) throw new Error('Collection request failed');
        const html = new DOMParser().parseFromString(await response.text(),'text/html');
        const grid = html.querySelector('[data-yc-grid]');
        const pagination = html.querySelector('[data-yc-pagination]');
        if (!grid || !pagination) throw new Error('Incomplete collection');
        const ids = new Set([...collection.querySelectorAll('[data-yh-card]')].map(e => e.dataset.productId));
        const cards = [...grid.querySelectorAll('[data-yh-card]')].filter(e => !ids.has(e.dataset.productId));
        collection.querySelector('[data-yc-grid]').append(...cards);
        collection.querySelector('[data-yc-pagination]').replaceWith(pagination);
        const first = cards[0]?.querySelector('a'); if (first) first.focus({preventScroll:true});
      } catch {
        error.hidden = false; link.textContent = link.dataset.label; link.removeAttribute('aria-disabled');
      } finally { busy = false; }
    });
  }
  setup(); document.addEventListener('shopify:section:load', event => setup(event.target));
})();
